import React from 'react';
import classNames from 'classnames';

import BaseButton from 'buttons/base-button';

import styles from './button.less';

class Button extends React.Component {
  static propTypes = {
    type: React.PropTypes.string,
    size: React.PropTypes.string
  }

  static defaultProps = {
    type: 'default'
  }

  getTypeClass(){
    var types = {
      'default': styles.default,
      'success': styles.success,
      'error': styles.error,
      'link': styles.link,
      'filled-success': styles.filledSuccess,
    }

    var type = types[this.props.type];

    if(!type){
      return 'type not found';
    }

    return type;
  }

  getSizeClass(){
    var sizes = {
      'medium': styles.medium
    };

    var size = sizes[this.props.size];

    return size;
  }

  getClass() {
    return classNames(styles.button, this.getTypeClass(), this.getSizeClass(), this.props.className);
  }

  render() {
    return (
      <BaseButton {...this.props} className={this.getClass()}>
        {this.props.children}
      </BaseButton>
    );
  }
}

module.exports = Button;



/** WEBPACK FOOTER **
 ** ./src/buttons/button/index.js
 **/